var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_c('p',{staticClass:"text-inherit hover:text-primary",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._v(_vm._s((new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })).format(_vm.params.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }